import { Stack } from '@mui/material';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import getLocalFile from '@/utils/getLocalFile';

const MarketInfo = dynamic(() => import('@/components/Sidebar/MarketInfo'));
const OtherMarkets = dynamic(() => import('@/components/Sidebar/OtherMarkets'));
const RelatedLinks = dynamic(() => import('@/components/Sidebar/RelatedLinks'));

const SideBar = () => {
  const {
    query: { symbol }
  } = useRouter();
  const marketName = symbol?.toString().toUpperCase() || '';
  const data = getLocalFile(marketName, 'info');

  return (
    <Stack gap={4}>
      {!data.Information.isScam && <MarketInfo />}
      <OtherMarkets symbols={data?.markets || []} />
      <RelatedLinks
        links={data?.cryptoInglance?.relatedLinks || []}
        name={data?.Information?.name_fa || ''}
      />
    </Stack>
  );
};

export default SideBar;
